import { useState } from "react";

import {
    IconCirclePlus,
    IconCircleMinus,
    IconTrash,
    IconX,
} from "@tabler/icons-react";

import { Button, Input, Text } from "@fragments";

import "./styles.scss";

const ADD_MAX_POINTS = 10000;

function PointsActionCard({
    icon,
    title,
    inputLabel,
    submitLabel,
    helperText,
    initialPoints,
    minPoints,
    maxPoints,
    loading,
    onSubmit,
    onClose,
}) {
    const [points, setPoints] = useState(initialPoints);

    async function handleSubmit() {
        const success = await onSubmit(points);

        if (success) {
            setPoints(initialPoints);
        }
    }

    return (
        <div className="admin-post-manage__expanded">
            <div className="admin-post-manage__expanded-header">
                <Text.h5 left={icon} contrast={8}>
                    {title}
                </Text.h5>
                <Button
                    icon={<IconX />}
                    variant="text"
                    color="inverse"
                    size="small"
                    preventLoading
                    onClick={onClose}
                />
            </div>

            <Input.Integer
                disabled={loading}
                value={points}
                onInput={setPoints}
                min={minPoints}
                max={maxPoints}
                label={inputLabel}
                fullWidth
                autoFocus
            />

            <Text.span contrast={5}>{helperText}</Text.span>

            <Button
                loading={loading}
                size="small"
                variant="default"
                color="inverse"
                onClick={handleSubmit}
                fullWidth
            >
                {submitLabel}
            </Button>
        </div>
    );
}

export default function AdminPostManageView({
    post,
    loading,
    onAddPoints,
    onDeducePoints,
    onDeletePost,
}) {
    const [addPointsOpen, setAddPointsOpen] = useState(false);
    const [deducePointsOpen, setDeducePointsOpen] = useState(false);

    const currentPoints = post?.insights?.points || 0;

    async function handleAddSubmit(points) {
        const success = await onAddPoints(points);

        if (success) {
            setAddPointsOpen(false);
        }

        return success;
    }

    async function handleDeduceSubmit(points) {
        const success = await onDeducePoints(points);

        if (success) {
            setDeducePointsOpen(false);
        }

        return success;
    }

    return (
        <div className="admin-post-manage px-3 pt-3">
            {addPointsOpen ? (
                <PointsActionCard
                    icon={<IconCirclePlus />}
                    title="Adicionar pontos"
                    inputLabel="Pontos a adicionar"
                    submitLabel="Adicionar"
                    helperText={`Adicione entre 1 e ${ADD_MAX_POINTS} pontos.`}
                    initialPoints={10}
                    minPoints={1}
                    maxPoints={ADD_MAX_POINTS}
                    loading={loading}
                    onSubmit={handleAddSubmit}
                    onClose={() => setAddPointsOpen(false)}
                />
            ) : (
                <Button
                    className="admin-post-manage__action-btn"
                    variant="text"
                    color="overlay"
                    fullWidth
                    preventLoading
                    onClick={() => setAddPointsOpen(true)}
                    startIcon={<IconCirclePlus />}
                >
                    Adicionar pontos
                </Button>
            )}

            {deducePointsOpen ? (
                <PointsActionCard
                    icon={<IconCircleMinus />}
                    title="Deduzir pontos"
                    inputLabel="Pontos a deduzir"
                    submitLabel="Deduzir"
                    helperText={`Deduza entre 1 e ${currentPoints} pontos disponíveis.`}
                    initialPoints={1}
                    minPoints={1}
                    maxPoints={currentPoints}
                    loading={loading}
                    onSubmit={handleDeduceSubmit}
                    onClose={() => setDeducePointsOpen(false)}
                />
            ) : (
                <Button
                    className="admin-post-manage__action-btn"
                    variant="text"
                    color="overlay"
                    fullWidth
                    preventLoading
                    disabled={!currentPoints}
                    onClick={() => setDeducePointsOpen(true)}
                    startIcon={<IconCircleMinus />}
                >
                    Deduzir pontos ({currentPoints} pts)
                </Button>
            )}

            <hr className="admin-post-manage__divider" />

            <Button
                className="admin-post-manage__action-btn"
                variant="text"
                color="error"
                fullWidth
                preventLoading
                onClick={onDeletePost}
                startIcon={<IconTrash />}
            >
                Apagar post
            </Button>
        </div>
    );
}
